import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class NocConfigurationService {
	private readonly BASE_PATH = '/shipment';

	constructor(private httpClient: HttpClient) { }

	saveNocConfiguration(configId: number, data: any): Observable<any> {
		return this.httpClient.post(`${this.BASE_PATH}/saveNocConfiguration`, { configId, data });
	}

	getAllNocConfigurations(): Observable<any> {
		return this.httpClient.get(`${this.BASE_PATH}/getNocConfigurations`);
	}

	getNocConfiguration(id: number): Observable<any> {
		return this.httpClient.get(`${this.BASE_PATH}/getNocConfiguration/${id}`);
	}

	deleteNocConfiguration(id: number): Observable<any> {
		return this.httpClient.delete(`${this.BASE_PATH}/deleteNocConfiguration/${id}`);
	}

	getEmailRecipients(): Observable<any> {
		return this.httpClient.get(`${this.BASE_PATH}/getEmailRecipients`);
	}

	deleteEmailRecipient(id: number): Observable<any> {
		return this.httpClient.delete(`${this.BASE_PATH}/deleteEmailRecipient/${id}`);
	}

	saveEmailRecipient(data: any): Observable<any> {
		return this.httpClient.post(`${this.BASE_PATH}/saveEmailRecipient`, { data });
	}
}
